import { render, staticRenderFns } from "./FilterCardUser.vue?vue&type=template&id=4523801e"
import script from "./FilterCardUser.vue?vue&type=script&lang=js"
export * from "./FilterCardUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports